<template>
	<div id="content_body">
		<!-- :instanceClass="instanceClassAttr.instanceClass" -->
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
									</label>
									<!-- || $store.getters.prsInfo.prsStore prsStoreSelected-->

									<select v-model="prsStoreSelected" 
										class="form-control" :class="{'is-invalid': v$.instance.prsStore.$error, 'is-valid': (!v$.instance.prsStore.$error && v$.instance.prsStore.$dirty) }" :disabled="typeView=='show' || !$store.getters.isAuthorized(['ROLE_MANAGER'])" @change="prsStoreChange()">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id" >
										{{ prsStore.storeName }}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsStore.$error">
										{{ v$.instance.prsStore.$errors[0].$message }}
									</span>									
								</b-form-group>
							</div>
							<div :class="($store.getters.isAuthorized(['ROLE_MANAGER']) && typeView !='edit')? 'col-md-3' : 'col-md-4'">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderNumber')}}
									</label>
									<input type="text" v-model="instance.orderNumber" class="form-control"
									:class="{'is-invalid': v$.instance.orderNumber.$error, 'is-valid': (!v$.instance.orderNumber.$error && v$.instance.orderNumber.$dirty) }" :disabled="typeView=='show' || instance.orderNumber"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderNumber.$error">
										{{ v$.instance.orderNumber.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div :class="($store.getters.isAuthorized(['ROLE_MANAGER']) && typeView != 'edit') ? 'col-md-3' : 'col-md-4'">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderDate')}}
									</label>
									<input type="date" v-model="instance.orderDate" class="form-control" lang="fr"
									:class="{'is-invalid': v$.instance.orderDate.$error, 'is-valid': (!v$.instance.orderDate.$error && v$.instance.orderDate.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderDate.$error">
										{{ v$.instance.orderDate.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>

							<div v-if="($store.getters.isAuthorized(['ROLE_MANAGER']) && typeView != 'edit')" class="col-md-2">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.payAuto')}}
									</label>
									<input type="checkbox" v-model="instance.payAuto" class="form-control" :disabled="typeView=='show'"/>
								</b-form-group>				
							</div>	

							<div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.personId')}}
									</label>
									<input v-if="['show', 'edit'].includes(typeView)" type="text" v-model="instance.person" class="form-control" disabled/>
									<!-- v-show="typeView != 'show'" -->
									<auto-search v-show="['new'].includes(typeView)" :paramsSearch="paramsSearch" @updateOnClick="addPerson" :key="autoSearchPrsKey" :class="{'is-invalid': v$.instance.personId.$error, 'is-valid': (!v$.instance.personId.$error && v$.instance.personId.$dirty) }" :disabled="typeView=='show'"/>
									<input type="text" v-model="instance.personId" class="form-control" :class="{'is-invalid': v$.instance.personId.$error, 'is-valid': (!v$.instance.personId.$error && v$.instance.personId.$dirty) }" hidden=""/> 
									<span style="color:red;" class="small d-none d-md-block" v-if="v$.instance.personId.$error">
										{{ v$.instance.personId.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							
						</div>
					</b-form>
					
				</div>
				<div class="card-body p-4 p-md-5">
					<!-- Ops table-->
					<div class="table-responsive">
						<span class="small text-muted d-none d-md-block" v-if="v$.instance.prodOrderItems.$error">
							{{ v$.instance.prodOrderItems.$errors[0].$message }}
						</span>
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="45%">
										{{ $t(instanceClassAttr.instanceClass+'.servType')}}
									</th>
									<th scope="col" width="30%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
									</th>
									<th scope="col" width="15%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.cost')}}
									</th>
									<th scope="col" v-if="typeView != 'show'" width="10%" class="align-center">
										{{ $t('default.actions')}}
									</th>
								</tr>
							</thead>
							<tbody>
								
								<tr class="border-bottom" v-for="prodOrderItem in instance.prodOrderItems" :key="prodOrderItem.id">
									<!--  -->
									<td>
										<div class="font-weight-bold">
											{{prodOrderItem.servTypeLib}} |
											<em style="color:red;">
												{{$store.getters.formatAmount(prodOrderItem.price)}}
											</em>
											<!-- <div>
												<h6>
													<b-badge variant="warning" style="color: white !important;">
														Prx: {{$store.getters.formatAmount(prodOrderItem.price)}} | Stock: {{prodOrderItem.stock}}
													</b-badge>
												</h6>
											</div> -->
										</div>
									</td>
									<td>
									<div class="input-group small text-muted">
										<input type="number" :max="prodOrderItem.stock" min="0" v-model="prodOrderItem.quantity" class="form-control" :disabled="typeView=='show'"
											@change="prsQteChange()"/>
										<span v-show="typeView !='show'" class="input-group-text text-danger">
											<b><em> Stock: {{prodOrderItem.stock}}</em></b>
										</span>
									</div>
										<!-- <div class="small text-muted d-none d-md-block">
											<input type="number" :max="prodOrderItem.stock" min="0" v-model="prodOrderItem.quantity" class="form-control" :disabled="typeView=='show'"
											@change="prsQteChange()"/>
										</div> -->
									</td>
									<td>
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount( prodOrderItem.price * prodOrderItem.quantity )}}
										</div>
									</td>
									<td v-if="typeView != 'show'" class="align-center">
										<!-- font-weight-bold -->
										<div class=""> 
											<button v-show="!prodOrderItem.edit" class="btn btn-danger btn-icon btn-xs" @click="removeRow(prodOrderItem)">
												<fa icon="minus"/>
											</button>
										</div>
									</td>
								</tr>
								<tr v-if="typeView != 'show'" class="border-bottom table-warning">
									<td v-show="activeAddRow" align="center" colspan="4" >
										<auto-search :paramsSearch="paramsSearchProduct" @updateOnClick="addRow" :key="autoSearchKey"/>
									</td>
									<td v-show="!activeAddRow" align="center" colspan="4"
									>
										<b-button class="btn btn-sm btn-success" 
											@click="activeAddRow=true; autoSearchKey++;" >
											<span>
												<fa class="fa-lg" icon="plus-circle"/>
											</span>
										</b-button>
									</td>
								</tr>
								<!-- DISCOUNT -->
								<tr v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="border-bottom table-warning">
									<td align="center" colspan="1" >
										<div class="fw-bold align-right" >
											{{ $t(instanceClassAttr.instanceClass+'.discount')}}
										</div>
									</td>
									<td align="center" colspan="3" >
										<div class="fw-bold align-right">
											<input type="number" step="any" v-model="instance.discount" class="form-control" :disabled="typeView=='show'" @input="amountToLetter($event, 'amount')" @change="amountLetter = {}; prsQteChange()"/>
											<span v-if="amountLetter && amountLetter.amount != '' " class="amount-letter">
												{{amountLetter.amount}}
											</span>

										</div>
									</td>
								</tr>

								<!-- TOTAL -->
								<tr v-if="instance.cost" class="border-bottom table-warning">
									<td align="center" colspan="1" >
										<div class="fw-bold fs-2 align-right" >
											Total de la comande
										</div>
									</td>
									<td align="center" colspan="3" >
										<div class="fw-bold fs-2 align-right">
											{{$store.getters.formatAmount(instance.cost)}}
										</div>
									</td>
								</tr>
								<tr v-if="amountLetter && amountLetter.cost" class="border-bottom table-warning">
									<!-- <td align="center" colspan="2" >
										<div class="fw-bold fs-2 align-right" >
											Total de la comande
										</div>
									</td> -->
									<td align="center" colspan="4" >
										<div class="fw-bold fst-italic align-right">
											{{amountLetter.cost}}
										</div>
									</td>
								</tr>

								<!-- OBSERVATION EN CAS DE RISTOURNE OU RETOUR -->
								<tr class="border-bottom table-warning">
									<td align="center" colspan="0" >
										<div class="fw-bold align-right" >
											{{ $t(instanceClassAttr.instanceClass+'.observation')}}
										</div>
									</td>
									<td align="center" colspan="4" >
										<div class="fw-bold align-left">
											<input type="text" v-model="instance.observation" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								
							</tbody>
						</table>
					</div>
				

				</div>

				<div class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])">
					<div class="row">
						
						<div class="col-md-6" align="left">
							<b-button v-if="typeView != 'show' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-dark" @click="editItem" >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show' && ['EP', 'EN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-primary" 
								@click="editItem" >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>
							&ensp;
							<!--  -->
							
							<b-button v-if="typeView == 'show' && ['EP', 'EN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-success" 
								@click="instance.typeValid = 'valid'; axiosValid()">
								<span>
									<fa icon="check"/>
									{{ $t("prodorder.button.valid")}}
								</span>
							</b-button>
							<b-button v-if="typeView == 'show' && ['LP', 'LN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-danger" 
								@click="instance.typeValid = 'invalid'; axiosValid()">
								<span>
									<fa icon="reply"/>
									{{ $t("prodorder.button.invalid")}}
								</span>
							</b-button>
						</div>
						<div v-if="typeView == 'show'" class="col-md-6" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce('bord')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('prodorder.button.bord')}}
							</b-button>
							&ensp;
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce('bill')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('prodorder.button.bill')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>


				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'	

	
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'prodOrder',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'auto-search': AutoSearch,
			'modal-pdf-viewer': ModalPdfViewer
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('prodorder.label'),
				pageTitle: this.$t('prodorder.list'),
				pageIcon: 'cart-plus',
				instanceClassAttr: {
					instanceClass: 'prodorder'
				},

				instance: {
					orderDate: new Date ().toISOString().split('T')[0],
					orderNumber: 'AUTO',
					person: '',
					prodOrderItems:[],
					discount: 0,
					payAuto: true,
					servStatus: {id:1} //si payAuto en cours
					// servStatus: {id:3} // en cours no payé
				},
				vueRules: {},
				amountLetter: {},
				paramsSearch: {
					placeholder: 'Search Client',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					defaultValue: this.instance?.person,
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				paramsSearchProduct: {
					placeholder: 'Search Products',
					attrView: 'lib',
					// defaultValue: this.instance?.person,
					filterList: [],
					listOpen: true,
					btnReturn: true,
					icon: 'cart-plus',
				},
				prsStoreList: [],
				prsStoreSelected: null,
				prsPersonList:[],
				prodOrderItems: {},

				// addOp
				activeAddRow: false,
				rowsAdded: {},
				typeView: 'new', // new, show, edit
				autoSearchPrsKey: 0,
				autoSearchKey: 0,

				pdfSrc:'',
				pdfName:'Facture',
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			
			this.$store.dispatch('initFlash');
			/*this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})*/
			if(this.$store.getters.loggedIn) {
				// GET orderNumber sequence
				await this.$store.dispatch('axiosGet', {
					url: '/api/sequence/getidgenereted?typeSeq=prodorder'
				})
				.then(response => {
					if(response.data)
						this.instance.orderNumber = response.data?.id
				})
				.catch(error => {
					console.log('error catch sequence == ', error.message)
				})
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					if(!this.$store.getters.isAuthorized(['ROLE_MANAGER']) && this.$store.getters.prsInfo.prsStore){
						this.prsStoreSelected = this.$store.getters.prsInfo.prsStore
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.prsStoreSelected)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})

				// GET LIST prsPersonList
				this.getPersonList()
				// GET LIST servTypeServStoreList
				this.getProducts()

				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'prodorder',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						this.instance = response.data
						// console.log('this.instance == ', this.instance)
						this.instance.orderDate = this.$moment(this.instance.orderDate).format('YYYY-MM-DD').toString()
						
						// NEW SI PAY AUTO
						if(this.instance.servStatus && (this.instance.servStatus.id == 3 ||this.instance.servStatus.id == 4) )
							this.instance.payAuto = false
						if(this.instance.servStatus && (this.instance.servStatus.id == 1 ||this.instance.servStatus.id == 2) )
							this.instance.payAuto = true

						this.instance.prodOrderItems = []
						this.instance.prodOrderItem.forEach(prodOrderItem => {
							// console.log('prodOrderItem.servTypeServStore == ', prodOrderItem.servTypeServStore)
							let products = {
								id: prodOrderItem.servType.id,
								lib: prodOrderItem.servTypeLib + ' | En Stock: '+prodOrderItem.servTypeServStore.stock+ ' '+prodOrderItem.servType.servUnitLib,
								servType: prodOrderItem.servType.id,
								servTypeLib: prodOrderItem.servTypeLib,
								servTypeStockS: prodOrderItem.servTypeServStore.servTypeServ.servTypeStockS.id,
								quantity: prodOrderItem.quantity,
								stock: prodOrderItem.servTypeServStore.stock,
								price: (prodOrderItem.cost / prodOrderItem.quantity ), // product?.servTypeServ?.servTypeStockS?.cost,
								cost: prodOrderItem.cost,
								edit: true
							}
							this.instance.prodOrderItems.push(products)
							this.amountToLetter({target:{value:this.instance.cost?.toString()}}, 'cost')
							
							// on charge les ops de production, en cas d'edit on aura comme new
							// if(prodOrderItem?.servTypeStockES?.servService?.serviceCode == 'P' )
							// 	this.instance.prodOrderItems?.push(prodOrderItem)
						})
						this.instance.prodOrderItem = [] // on annule l'objet hasMany pour traitement spécial
						this.prsStoreSelected = this.instance.prsStore.id
						this.paramsSearch.defaultValue = this.instance.person
						this.autoSearchPrsKey=+1;

					})
					.catch(error => {
						console.log('error catch get prodorder by itemId == ', error.message)
					})
				}
			}
			this.pageTitle = this.$t('prodorder.'+this.typeView)
		},
		methods: {
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// CL -> 2
				strParams = strParams+"&aliasList=_prsType,_prsStore"
				strParams = strParams+"&params1=_prsType.id&valParams1="+2+"&logParams1=eqL"
				if(this.prsStoreSelected && this.prsStoreSelected != null)
					strParams = strParams+"&params2=_prsStore.id&valParams2="+this.prsStoreSelected+"&logParams2=eqL"
				
				strParams = strParams+"&params3=active&valParams3="+true+"&logParams3=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
					// console.log('this.paramsSearch.filterList = ', this.paramsSearch.filterList)
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

			},
			async getProducts(){
				this.instance.prodOrderItems = []
				this.paramsSearchProduct.filterList = []
				let strParams = "typeRender=list"
				strParams = strParams+"&aliasList=_servTypeServ,_prsStore"

				// strParams = strParams+"&attrOrder=_servTypeServ.servType.id&typerOrder=asc"
						
				// Stock diff de 0
				strParams = strParams+"&params1=stock&valParams1="+0+"&logParams1=neI"
				
				// Serv Vente : 3
				strParams = strParams+"&params2=_servTypeServ.servService.id&valParams2="+3+"&logParams2=eqL"

				if(this.prsStoreSelected && this.prsStoreSelected != null)
					strParams = strParams+"&params3=_prsStore.id&valParams3="+this.prsStoreSelected+"&logParams3=eqL"

				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtypeservstore/getbycriteria?' + strParams
				})
				.then(response => {
					let products = response.data
					// console.log('products == ', products)
					// products = products.sort((a, b) => a.servTypeLib - b.servTypeLib)
					products?.forEach(product =>{
						if(product){
							let prodOrderItem = {
								id: product.servType.id,
								lib: product.servTypeLib + ' | En Stock: '+product.stock+ ' '+product.servType.servUnitLib,
								servType: product.servType.id,
								servTypeLib: product.servTypeLib,
								servTypeStockS: product.servTypeServ.servTypeStockS.id,
								quantity: 0,
								stock: product.stock,
								price: product?.servTypeServ?.servTypeStockS?.cost,
								cost: ''
							}
							this.paramsSearchProduct.filterList.push(prodOrderItem)
							
							// this.instance.prodOrderItems =  this.instance.prodOrderItems.sort()
							// this.instance.prodOrderItems = this.instance.prodOrderItems.sort((a, b) => a.servTypeLib - b.servTypeLib)
							// cas edit
							this.prodOrderItems[product.servTypeLib] = prodOrderItem
						}
						
					})
					
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})
			},
			prsStoreChange(){
				// 1 - on change liste des clients et products selon store
				this.getPersonList()
				this.getProducts()
			},
			/*prsQteChange(){
				this.instance.cost = 0;
				this.instance.prodOrderItems?.forEach(product =>{
					this.instance.cost = this.instance.cost + (product.price * product.quantity) 
				});
				this.instance.cost = this.instance.cost - this.instance.discount
			},*/
			prsQteChange(){
				this.instance.ht = 0;
				this.instance.prodOrderItems?.forEach(product =>{
					this.instance.ht = this.instance.ht + (product.price * product.quantity) 
				});
				this.instance.cost = this.instance.ht - this.instance.discount //+this.instance.tax
			},
			async editItem(){
				if(this.typeView == 'edit')
					this.$router.go(0)
				else {
					this.typeView = 'edit'
					// on ajoute les autres stocks
					this.instance.prodOrderItems.forEach(prodOrderItem => {
						if(this.prodOrderItems[prodOrderItem.servTypeLib]){
							//prodOrderItem.stock = this.prodOrderItems[prodOrderItem.servTypeLib].stock
							delete this.prodOrderItems[prodOrderItem.servTypeLib];
						}
					})
					let prodOrderItems = Object.values(this.prodOrderItems);
					// this.instance.prodOrderItems.push(...prodOrderItems);
					this.paramsSearchProduct.filterList = []
					this.paramsSearchProduct.filterList.push(...prodOrderItems)
				}
			},
			createVeerules(){
				let rules = {
					instance: {
						orderDate: { required },
						orderNumber: {required},
						prsStore: {required},
						personId: {required},
						prodOrderItems: {required},
					}
				}
				return rules
			},
			removeRow(row){
				let newList = this.instance.prodOrderItems.filter(item => item.servTypeLib !== row.servTypeLib)
				this.instance.prodOrderItems = newList
				this.paramsSearchProduct.filterList.push(this.rowsAdded[row.servTypeLib])
			},
			addRow(row){
				if(row){
					// on restraint la liste filter after click
					let newList = this.paramsSearchProduct.filterList.filter(item => item.servTypeLib !== row.servTypeLib)
					this.paramsSearchProduct.filterList = newList
					
					// cas edit, on bloque l'élement existant dans l'opération
					const idRowsAdded = this.instance.prodOrderItems.map(item => item.servTypeLib);
					if(idRowsAdded?.includes(row.servTypeLib)){
						this.$store.dispatch('showToast', {
							type: 'warning', message: row.servTypeLib +' déja choisis'
						});
					}
					else {
						this.instance.prodOrderItems.push(row)
						this.rowsAdded[row.servTypeLib] = row
					}
				
				}
				if(this.activeAddRow)
					this.activeAddRow = false
				else
					this.activeAddRow = true
			},
			
			addPerson(row){
				if(row){
					this.instance.personId = row.id?.toString()
					this.instance.livreur = row.id?.fullName
				}
				else {
					this.instance.personId = ''
					this.instance.livreur = ''
				}
			},
			amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async handleSubmit() {
				this.instance.prsStore = this.prsStoreSelected
				//  AUTO 
				if(this.instance.payAuto)
					this.instance.servStatus = {id:1}
				else
					this.instance.servStatus = {id:3}

				const result = await this.v$.$validate()
				if (!result){
					return
				}
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'prodorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res update === ', res)
							this.$nextTick(() => {
								let msg = this.$t("prodorder.label") + " N° "+res.data?.orderNumber;
								
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.typeView = 'show'
									this.$router.push('/prodorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.typeView = 'show'
								// this.$router.push('/prodorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error update === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'prodorder',
							data: this.instance //data
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("prodorder.label") + " N° "+res.data?.orderNumber;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
								this.$router.push('/prodorder/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							// console.log('Error', error.response)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async axiosValid() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'prodorder/validorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res axiosValid === ', res)
							this.$nextTick(() => {
								let msg = this.$t("prodorder.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/prodorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.received.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.$router.go(0)
								// this.$router.push('/prodorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosValid === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async produce(typePrint) {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'FACTURE'
				let attrsRepList = ['servType', 'getPrice()', 'quantity', 'cost']
				let attrsRepLibList = ['Produit', 'P.U', 'Qté.', 'Montant']
				if(typePrint == 'bord'){
					modelName = 'BORDEREAU DE LIVRAISON'
					attrsRepList = ['servType', 'quantity', 'tdObs'] //, 'obs'
					attrsRepLibList = ['Produit', 'Qté.', 'Observation']
				}

				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';
				let detailsTopC1 = '<i>'+ this.$t(this.instanceClassAttr.instanceClass +'.personId')+' : </i> <b> ' +this.instance.personInfo.name + '</b>';
				detailsTopC1 = detailsTopC1 + '<br> <i>'+ this.$t('prsperson.address') +' : </i> <b> ' +this.instance.personInfo.address + '</b>';
				detailsTopC1 = detailsTopC1 + '<br> <i>'+ this.$t('prsperson.phoneAddress') +' : </i> <b> ' +this.instance.personInfo.phoneAddress + '</b>';
				
				let	detailsTopC2 = '<i> '+ this.$t('prodorder.orderNumber') +' : </i> <b> ' +this.instance.orderNumber + '</b>';
				detailsTopC2 = detailsTopC2 + '<br><i> Bamako le, </i> <b>' + this.$moment(this.instance.orderDate).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''
				let	detailsBot = ''
				if(typePrint == 'bill'){
					trFoot = '<i> '+ this.$t('prodorder.ht') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.ht) + '</b>';
				
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('prodorder.discount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.discount) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('prodorder.tax') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.tax) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('prodorder.ttc') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.cost) + '</b>';
				
					detailsBot = '<i> '+ this.$t('prodorder.amountLetter') +' : <b> '+this.amountLetter.cost +'</b> </i>';
				}

				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot
				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot

				let strParamsForms = "params1=prodOrder.id&valParams1="+this.itemId +"&logParams1=eqL"
				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()
				strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.prodOrderItem')

				let fileName = modelName + '_'+this.instance.orderNumber+ '_'+this.instance.personInfo.name
				strParams = strParams + "&fileName="+ fileName
				strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.prsStore?.storeName +' ***</i></FONT> '
				await this.$store.dispatch('axiosGet', {
					url: '/api/prodorderitem/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},

		}
	}

</script>